import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ValidateResetTokenResponse {
    valid: boolean;
    purpose: string | null;
}

export interface ResetPasswordResponse {
    /** Solo tras activar una cuenta que pidió Authenticator: token de /auth/register/authenticator/{token}. */
    authenticatorToken: string | null;
}

@Injectable({ providedIn: 'root' })
export class SetPasswordService {
    private readonly http = inject(HttpClient);

    validateToken(token: string): Observable<ValidateResetTokenResponse> {
        return this.http.get<ValidateResetTokenResponse>(
            `${environment.config.api_url}Auth/ValidateResetToken`, { params: { token } });
    }

    resetPassword(token: string, newPassword: string): Observable<ResetPasswordResponse> {
        return this.http.post<ResetPasswordResponse>(`${environment.config.api_url}Auth/ResetPassword`, { token, newPassword });
    }
}
